import { useSelector } from 'react-redux';

export function useUser() {
  const {
    merchants,
    scopes,
    email,
    hasIncompleteOnboardingStore,
    storesWithIncompleteOnboarding,
  } = useSelector((state) => state.user);

  const userHasScope = (userScope) => {
    if (Array.isArray(userScope)) {
      let hasAllPermissions = false;

      userScope.map((scope) => {
        hasAllPermissions = scopes.includes(scope);

        return scope;
      });

      return hasAllPermissions;
    }

    return scopes.includes(userScope);
  };

  // Check if AI assistant is enabled for any of the user's merchants
  const isAIAssistantEnabled =
    Array.isArray(merchants) &&
    merchants.some(
      (merchant) =>
        merchant?.accountConfigurations?.isAIAssistantEnabled === true
    );

  return {
    merchants,
    scopes,
    userHasScope,
    email,
    isAIAssistantEnabled,
    hasIncompleteOnboardingStore,
    storesWithIncompleteOnboarding,
  };
}
